import React from 'react';

/**
 * SilentErrorBoundary - An error boundary that renders nothing on error.
 *
 * Used to wrap non-critical UI components (like BreadcrumbBar) so that
 * if they throw during render, the rest of the page still loads normally.
 */
class SilentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('SilentErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

export default SilentErrorBoundary;
